import Luiv3Constants, {LuiV3ColorKey} from '@app/lui3/constants';
import styled from 'styled-components';

import AbsLayer from './AbsLayer';

interface Props {
  backgroundColor: LuiV3ColorKey;
}

const FilledDisabledBaseLayer = styled(AbsLayer)<Props>`
  background-color: ${({backgroundColor}) =>
    Luiv3Constants.baseColor[backgroundColor]};
  opacity: 0.38;
`;

export default FilledDisabledBaseLayer;
